const theme = {
  colors: {
    black: '#212121',
    gray: '#757575'
  }
}

export default theme
